import _fu0mxkrTDaLlb3VQWIIy from '../dictionary/common.json' with { type: 'json' };
import _CmSebRcOkCEcR3RtPhhh from '../dictionary/cookies.json' with { type: 'json' };
import _ojgmldoknASHz8eiobmc from '../dictionary/errors.json' with { type: 'json' };
import _7WQt0RHF4JTPv6oLf1Y3 from '../dictionary/footer.json' with { type: 'json' };
import _hfcnyvZsRq83jjP8L7De from '../dictionary/header.json' with { type: 'json' };
import _8hC3VLZz8cviacm1gH1w from '../dictionary/landing.json' with { type: 'json' };
import _LA69GDEhrH7UhiHfvJKi from '../dictionary/privacy.json' with { type: 'json' };

const dictionaries = {
  "common": _fu0mxkrTDaLlb3VQWIIy,
  "cookies": _CmSebRcOkCEcR3RtPhhh,
  "errors": _ojgmldoknASHz8eiobmc,
  "footer": _7WQt0RHF4JTPv6oLf1Y3,
  "header": _hfcnyvZsRq83jjP8L7De,
  "landing": _8hC3VLZz8cviacm1gH1w,
  "privacy": _LA69GDEhrH7UhiHfvJKi
};
const getDictionaries = () => dictionaries;

export { getDictionaries };
export default dictionaries;
